createMakeWatchQueryOptions